var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShieldGold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.623,
    height: 32,
    viewBox: "0 0 28.623 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1002",
    "data-name": "Group 1002",
    transform: "translate(-182 -143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_915",
    "data-name": "Path 915",
    d: "M196.311,143h-8.53s-.172,4.809-5.782,6.469c0,0,.229,10.075,3.435,15.857,3.721,6.583,10.877,9.674,10.877,9.674s7.156-3.091,10.877-9.674c3.206-5.782,3.435-15.857,3.435-15.857-5.61-1.66-5.782-6.469-5.782-6.469Z",
    fill: "#f4ae3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_913",
    "data-name": "Path 913",
    d: "M213.627,176.053Zm0-.744c1.832-.973,6.64-3.778,9.331-8.587,2.29-4.179,2.977-11.106,3.148-13.8a8.95,8.95,0,0,1-5.381-5.9h-7.1v28.279Z",
    transform: "translate(-17.316 -2.255)",
    fill: "#e59c33"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldGold);
export default __webpack_public_path__ + "static/media/shield-gold.e8057ef7bac3fb126e7b773e0153475a.svg";
export { ForwardRef as ReactComponent };